import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

const esObjectId = (v) => /^[a-f\d]{24}$/i.test(String(v || ""));

class SelectListasEscuelaItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: true,
      texto: "",
    };
    this.buscarListas = debounce(this.buscarListas.bind(this), 300);
  }

  componentDidMount() {
    this.buscarListas("", true);
    if (this.props.value) this.asegurarValor(this.props.value);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.value) {
      this.asegurarValor(this.props.value);
    }
  }

  async asegurarValor(value) {
    const val = value?.toString();
    if (!val || !esObjectId(val)) return;
    if (this.state.opciones.some((o) => o._id?.toString() === val)) return;
    try {
      const res = await axios.post(
        "listasEscuela/selectListasEscuelaItem",
        {
          query: val,
          skip: 0,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2 && res.data.listas?.length) {
        this.setState((prev) => {
          const existentes = new Set(
            prev.opciones.map((o) => o._id?.toString())
          );
          const nuevos = res.data.listas.filter(
            (l) => !existentes.has(l._id?.toString())
          );
          return { opciones: [...nuevos, ...prev.opciones] };
        });
      }
    } catch (err) {
      console.error(err);
    }
  }

  async buscarListas(texto, inicial, append = false) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "listasEscuela/selectListasEscuelaItem",
        {
          query: append ? this.state.texto || "" : texto || "",
          skip: append ? this.state.opciones.length : 0,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        this.setState(
          (prev) => ({
            opciones: append
              ? [...prev.opciones, ...res.data.listas]
              : res.data.listas,
            primerCarga: false,
            texto: append ? prev.texto : texto,
          }),
          () => {
            // Tras un reset, reasegurar el value seleccionado.
            if (!append && this.props.value)
              this.asegurarValor(this.props.value);
          }
        );
      } else {
        this.setState({ opciones: [] });
      }
    } catch (err) {
      console.error(err);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  render() {
    const { noBuscar, disabled, sinBorde, width, style, placeholder, ...rest } =
      this.props;
    const opcionesUnicas = [];
    const vistos = new Set();
    for (const l of this.state.opciones) {
      const id = l._id?.toString();
      if (vistos.has(id)) continue;
      vistos.add(id);
      opcionesUnicas.push(l);
    }

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={false}
        disabled={disabled}
        showSearch={!noBuscar}
        filterOption={false}
        onSearch={this.buscarListas}
        loading={this.state.cargando}
        notFoundContent={
          this.state.cargando ? "Buscando..." : "No se encontraron listas"
        }
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>{menu}</Spin>
        )}
        {...rest}
        onChange={(value) => {
          const lista = this.state.opciones.find((e) => e._id === value);
          if (this.props.onChange) this.props.onChange(value, lista);
        }}
        placeholder={placeholder}
        style={{ width: width || "100%", ...style }}
        bordered={!sinBorde}
        onPopupScroll={(e) => {
          const { target } = e;
          if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
            this.buscarListas(this.state.texto || "", false, true);
          }
        }}
      >
        {opcionesUnicas.map((l) => (
          <Option key={l._id} value={l._id}>
            {l.stringBuscar || l.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectListasEscuelaItem;
